import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';

declare var $:any
@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public currentUrl:any ='';
  public token:any='';
  public usertYpes:any='';
  public type:any=1;

  forgotData = new FormGroup({
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email])), 
  })

  resetData = new FormGroup({
    password: new FormControl('',Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') ])),
    confirm_password: new FormControl('',Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}') ])),     
  })
  
  get f() { return this.forgotData.controls; }

  get f1() { return this.resetData.controls; }

  constructor(public router: Router, private service: GlobalService) { }

  ngOnInit(): void {
    var mm:any =(this.router.url).split('/');
    this.currentUrl ='/'+ mm[1];
    if(mm.length ==3){
      if( mm[2].includes("?")){
        var ss:any=mm[2].split('?')
        this.token = ss[0];
        var ssd:any= ss[1].split('=');
        this.usertYpes=ssd[1];
      } else {
        this.token = mm[2];
      }
      
    }
  }

  Onsubmit(){
    this.submitted = true;
    let userDetail = this.forgotData;
      if(userDetail.valid){
        this.loading = true;
        const url = "/forgot-password";
        const detail = {
          "email": (userDetail.value.email)?.toLowerCase()
        };
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) {
            this.submitted = false;
            localStorage.setItem('grw_userId',response.data.user_id);
            localStorage.setItem('grw_resetpass','1');
            this.service.successAlert(response.message);
            this.router.navigate(['/']);
            this.loading = false;
          } else {
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        }), (error) => { this.loading =false; });
      } else{
        this.type=1;
        // window.scroll(0,0);
      }
  }

  OnReset(){
    this.submitted = true;
    let userDetail = this.resetData;
      if(userDetail.valid){
        this.loading = true;
        const url = "/update-forgot-password";
        const detail = {
          "token":this.token,
          "new_password": userDetail.value.password,
          "confirm_password":  userDetail.value.confirm_password,
        };
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) {
            this.submitted = false;
            localStorage.removeItem('grw_resetpass');
            this.service.successAlert(response.message);
            $('#passlink').trigger('click');
            this.loading = false;
            this.router.navigate(['/']);
          } else {
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        }), (error) => { this.loading =false; });
      } else{
        window.scroll(0,0);
      }
  }

  redirect(){
    $('#Sendpasswordresetlink').modal('toggle');
    this.router.navigate(['/signin'])
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa-regular fa-eye-slash");
      $(str).addClass("fa-regular fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("fa-regular fa-eye ");
      $(str).addClass("fa-regular fa-eye-slash");
    }
  }

  contactAdmin(){
    this.submitted = true;
    let userDetail = this.forgotData;
      if(userDetail.valid){
        this.loading = true;
        const url = "/contact-admin";
        const detail = {
          "email": userDetail.value.email,
          // "role_id": '',
        };
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1) {
            this.submitted = false;
            // localStorage.removeItem('grw_resetpass');
            // this.service.successAlert(response.message);
            // $('#passlink').trigger('click');
            this.loading = false;
            this.router.navigate(['/']);
          } else {
            this.service.dangerAlert(response.message);
            this.loading = false;
          }
        }), (error) => { this.loading =false; });
      } else{
        this.type=2;
        window.scroll(0,0);
      }
  }
}

